
import { Options, Vue } from 'vue-class-component';
import { format } from 'date-fns';

import ScheduleTable from '@/components/App/ScheduleTable.vue';
import { useQuery } from '@vue/apollo-composable';
import { GetMonthsDocument, Month, Person } from '@/graphql/generated-operations';
import { Prop } from 'vue-property-decorator';

@Options({
  components: {
    ScheduleTable,
  },
})
export default class Schedule extends Vue {

  @Prop({default: null})
  user!: Person;

  months: Month[] = [];
  selectedMonth: Month | null = null;

  loading = true;

  created() {
    const { onResult } = useQuery(GetMonthsDocument, {
      personID: this.user.id
    });

    onResult(queryResult => {
      this.months = queryResult.data.getMonths;

      const currentMonth = format(new Date(), 'y-MM');
      this.months.map((month, index) => {
        if ( month.key == currentMonth ) {
          this.selectedMonth = this.months[index];
        }
      });

      this.loading = false;
    });
  }

}
